import React from 'react';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible name — required; icon buttons have no visible text label */
  'aria-label': string;
  /** Renders the overlay variant for use on imagery (semi-transparent bg + blur) */
  onImagery?: boolean;
  children?: React.ReactNode;
}

export const IconButton: React.FC<IconButtonProps> = ({
  onImagery = false,
  disabled = false,
  children,
  className = '',
  ...rest
}) => {
  const base = [
    // Design system glass: botão só-ícone quadrado de raio 10.
    'w-9 h-9 rounded-control flex items-center justify-center',
    'transition-colors duration-150',
    'active:scale-95',
    // Focus ring is mandatory on every icon button — pitfall per DESIGN-CRAFT §2
    'focus-visible:outline-none focus-visible:ring-snapfy-focus',
  ].join(' ');

  const variantClasses = onImagery
    ? [
        'bg-white/20 backdrop-blur-sm text-white',
        'hover:bg-white/30',
      ].join(' ')
    : [
        'text-snapfy-text-secondary',
        'hover:bg-snapfy-control hover:text-snapfy-text-primary',
      ].join(' ');

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      {...rest}
      disabled={disabled}
      className={`${base} ${variantClasses} ${disabledClasses} ${className}`.trim()}
    >
      {children}
    </button>
  );
};

export default IconButton;
